import {
  GoAAccordion,
  GoAButton,
  GoAButtonGroup,
  GoAContainer,
  GoAIcon,
  GoASpacer,
} from '@abgov/react-components';
import React, { useEffect } from 'react';
import { AppDispatch, RootState } from '../../state/store';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import {
  isLawEnforcementOfficer,
  loadCsrUser,
} from '../../state/slices/authSlice';
import {
  pushNotification,
  removeAllValidationErrorNotifications,
} from '../../state/slices/notificationSlice';
import { lawConfig } from '../../utils/oidcConfig';
import useCsrService from '../../services/csr-api-redux';
import { REACT_ALBERTA_CA_ACCOUNT_URL } from '../../state/configuration';

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected,
) => TSelected = useSelector;

interface LawLandingComponentProps {}

export const LawEnforcementLandingComponent =
  ({}: LawLandingComponentProps) => {
    const lawDashboardPath = `${window.location.protocol}//${window.location.host}/law/dashboard`;
    const csrService = useCsrService();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { signinRedirect } = useAuth();

    const stateAuth = useAppSelector((state: RootState) => state.auth);

    const handleLawEnforcementLoginClick = () => {
      dispatch(removeAllValidationErrorNotifications());
      signinRedirect({
        //redirect_uri: lawDashboardPath,
        ...lawConfig,
      });
    };

    useEffect(() => {
      if (stateAuth.auth.access && stateAuth.auth.access.access) {
        dispatch(loadCsrUser({ csrService }));
      }
    }, [stateAuth.auth.access]);

    useEffect(() => {
      if (stateAuth.auth.access.access) {
        if (isLawEnforcementOfficer(stateAuth)) {
          navigate('/law/dashboard', { replace: true });
        } else {
          // no need to display an error
        }
      }
    }, [stateAuth]);

    return (
      <div style={{ maxWidth: '800px', margin: 'auto', padding: '20px' }}>
        <h1>Sign in or sign up</h1>
        <GoASpacer vSpacing={'l'} />

        <div style={{ display: 'flex', gap: '10px' }}>
          <GoAIcon mr={'2xs'} type="shield" size={'large'} />
          <span style={{ font: 'var(--goa-typography-body-m)' }}>
            Your information is kept secure.{' '}
            <a href="#" style={{ marginLeft: '5px', color: '#007bff' }}>
              Learn more
            </a>
          </span>
        </div>
        <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
          {/* Law Enforcement Users */}
          <GoAContainer
            accent="thin"
            type="interactive"
            width="full"
            maxWidth="472px"
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <h3 style={{ width: '350px' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <GoAIcon
                    type="person"
                    size={'medium'}
                    fillColor="rgba(0, 112, 196, 1)"
                  />
                  <GoASpacer hSpacing={'xs'} />
                  Law enforcement users
                </span>
              </h3>

              <GoASpacer vSpacing={'m'} />
              <p style={{ fontSize: '14px', color: '#333' }}>
                Sign in using your Alberta.ca Account for Organizations (AAO)
                credentials.{' '}
                <strong>
                  You must have been added to the Organization in AAO to be able
                  to access Report My Collision.
                </strong>
              </p>
              <span style={{ flexGrow: 1 }}> </span>

              <div
                style={{
                  display: 'flex',
                }}
              >
                <GoAButtonGroup alignment="start">
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <GoAButton
                      type="primary"
                      trailingIcon="arrow-forward"
                      onClick={() => {
                        handleLawEnforcementLoginClick();
                      }}
                    >
                      Sign in
                    </GoAButton>
                    <span>or</span>
                    <GoAButton
                      type="tertiary"
                      onClick={() => {
                        window.location.href =
                          REACT_ALBERTA_CA_ACCOUNT_URL +
                          'ui-test/sign-in/create-new-business-account';
                      }}
                    >
                      Create a new account
                    </GoAButton>
                  </div>
                </GoAButtonGroup>
              </div>
            </div>
          </GoAContainer>
        </div>
      </div>
    );
  };
